<script>
import ModalWorkHistorySP from '@/views/pages/daily_reports/modals/sp/ModalWorkHistory.vue';

export default {
  name: "work_order_information",
  components: {
    WorkOrderTypeBadge: () => import('@/components/Common/WorkOrderTypeBadge.vue'),
    ModalWorkHistorySP
  },
  props: {
    workOrder: {
      type: Object,
      default: () => { }
    },
  },
  methods: {
    getDischargerName(cases){
      return (cases && cases.discharger) ? cases.discharger.name_abbreviated : ''
     },
     getDischargerAddress(cases){
      return [
        this.$helpers.formatZipCode(cases?.discharger?.zip),
        cases?.discharger?.address_1,
        cases?.discharger?.address_2,
        cases?.discharger?.address_3,
        cases?.discharger?.address_4,
      ].filter(x => !!x).join('')
    },
    getDischargerTel(cases) {
      return cases
        ? cases.discharger?.tel
        : "";
    },
     getDischargerSiteAddress(cases){
      return [
        this.$helpers.formatZipCode(cases?.discharger_site?.zip),
        cases?.discharger_site?.address_1,
        cases?.discharger_site?.address_2,
        cases?.discharger_site?.address_3,
        cases?.discharger_site?.address_4,
      ].filter(x => !!x).join('')
    },
    getDischargerSiteName(cases){
      return (cases && cases.discharger_site) ? cases.discharger_site.name_abbreviated : ''
    },
    getDischargerSiteTel(cases) {
      return cases
        ? cases.discharger_site?.tel
        : "";
    },
    openworkHistoryModal() {
      this.$refs.workHistory.openModal(this.workOrder.id, this.workOrder.name);
    },
  },
  computed: {
    isDisplayChecklistEducation() {
      if (!this.workOrder || !this.workOrder?.checklists?.length) return false;

      return this.workOrder.checklists.some(checklist => checklist.pivot.zz_checkup_work_item_id === this.$constant.zzCheckUpWorkItems.campus_entrance_education);
    },
    isWdsShipAfterTreatment() {
      if (!this.workOrder) return false;

      return this.workOrder.is_wds_ship_after_treatment;
    },
  },
}
</script>

<template>
  <b-card>
    <b-row>
      <b-col>
        <h4>
          <div class="mb-3 title-detail">■作業指示内容</div>
        </h4>
      </b-col>
      <b-col class="text-end">
        <button
          @click="openworkHistoryModal()"
          class="btn btn-primary waves-effect waves-light"
        >
          <i class="fas fa-history"></i> 作業履歴
        </button>
      </b-col>
    </b-row>
    <div class="mb-3">
      <h4>
        <WorkOrderTypeBadge
          :work-order-type="workOrder.work_order_type"
        />
      </h4>
    </div>
    <div class="mb-1 d-flex col-gap-5 flex-wrap">
      <div>
        <span class="lbl-custom">作業指示番号：</span>
        <span>{{ workOrder.id }} </span>
      </div>
      <div>
        <span class="lbl-custom">作業指示名：</span>
        <router-link
          :to="{ name: 'projects.sales.instructions.detail', params: { id: workOrder.case_id, work_order_id: workOrder.id  }, query: { readonly: true } }"
        >
          {{ workOrder.name }}
        </router-link>
      </div>
    </div>
    <div class="mb-1 d-flex col-gap-5 flex-wrap">
      <div>
        <span class="lbl-custom">事業者：</span><span>{{ getDischargerName(workOrder.case) }} </span>
      </div>
        <div>
          <span class="lbl-custom">住所：</span>
          <span v-if="workOrder.case && workOrder.case.discharger"> {{ getDischargerAddress(workOrder.case) }}</span>
        </div>
        <div>
          <span class="lbl-custom">電話：</span>
          <span v-if="workOrder.case && workOrder.case.discharger"> {{ getDischargerTel(workOrder.case) }}</span>
        </div>
      </div>
      <div class="mb-1 d-flex col-gap-5 flex-wrap">
        <div>
          <span class="lbl-custom">事業場：</span><span>{{ getDischargerSiteName(workOrder.case) }}</span>
        </div>
        <div>
          <span class="lbl-custom">住所：</span>
          <span v-if="workOrder.case && workOrder.case.discharger_site"> {{ getDischargerSiteAddress(workOrder.case) }}</span>
        </div>
        <div>
          <span class="lbl-custom">電話：</span>
          <span v-if="workOrder.case && workOrder.case.discharger_site"> {{ getDischargerSiteTel(workOrder.case) }}</span>
        </div>
      </div>
    <div class="mb-1 d-flex flex-wrap ">
      <span class="lbl-custom">作業人数：</span><span>{{ workOrder.number_of_staffs_delivered }} 名</span>
      <span class="ms-4"
        v-for="(item, index) in workOrder.qualifications"
        :key="index"
      >
        {{ item.qualification }}×{{ item.pivot.number_of_staffs }}
      </span>

      <span class="lbl-custom ms-5" v-if="isDisplayChecklistEducation">入構教育</span>
      <span class="lbl-custom ms-3" v-if="isWdsShipAfterTreatment">即出荷</span>
    </div>
    <div class="mb-1 d-flex flex-wrap">
      <span class="lbl-custom">車両：</span>
      <span class="ms-4"
        v-for="(item, index) in workOrder.car_types_by_work_order"
        :key="index"
      >
        {{ item.invoice_product_name }}×{{ item.pivot.number_of_cars }}
      </span>
    </div>
    <div class="mb-1 d-flex flex-wrap col-gap-3">
      <div>
        <span class="lbl-custom">標準作業時間： {{ workOrder.standard_working_hours | durationHours }}</span>
      </div>
      <div>
        <span class="lbl-custom">標準作業時間（往復）： {{ workOrder.standard_travel_hours | durationHours }}</span>
      </div>
      <div>
        <span class="lbl-custom">標準荷卸時間 ： {{ workOrder.standard_unloading_hours | durationHours }}</span>
      </div>
      <div>
        <span class="lbl-custom">標準合計時間： {{ workOrder.standard_total_hours | durationHours }}</span>
      </div>
    </div>
    <div class="mb-1 d-flex flex-wrap">
      <span class="lbl-custom me-2">単独・合積：</span>
      <span>{{workOrder.mixed_loading_kbn ? workOrder.mixed_loading_kbn.toString() === '1' ? '単独' : '合積' : ''}}</span>
    </div>
    <ModalWorkHistorySP
        ref="workHistory"
    />
  </b-card>
</template>

<style scoped>
.lbl-custom {
  font-weight: 600;
}

.title-detail {
  font-size: 16px;
  font-weight: 600;
}

.col-gap-5 {
  column-gap: 5rem !important;
}

.col-gap-3 {
  column-gap: 3rem !important;
}
</style>
